import React, { FC } from 'react'
interface dataTypes {
    register: any,
    errors: any,
    handleChange: (Value: any) => void,
    values: any
}
const BasicInfo: FC<dataTypes> = ({ register, errors, handleChange, values }) => {
  return (
    <div className="card emp-card bg-light shadow-sm">
        <div className="card-header rounded bg-warning text-dark">
            <h5>Basic Information</h5>
        </div>
        <div className="card-body">
            <div className="container-fluid">
                <div className="row justify-content-between">
            <div className="row">
                <div className='col-lg-4 col-md-12 col-sm-12 rounded-0'>
                    <label>First Name <span className='text-danger'>*</span></label>
                    <input type="text" className='form-control' {...register('firstname', { required: 'Please insert your firstname' })} onChange={handleChange} />
                    {errors.firstname && <span className='text-danger'>{errors.firstname.message}</span>}
                </div>
                <div className="col-lg-4 col-md-12 col-sm-12">
                    <label>Middle Name</label>
                    <input type={'text'} className='form-control' {...register('middlename')} onChange={handleChange} />
                    {errors.middlename && <span className='text-danger'>{errors.middlename.message}</span>}
                </div>
                <div className="col-lg-4 col-md-12 col-sm-12">
                    <label>Surname <span className="text-danger">*</span></label>
                    <input type={'text'} className='form-control' {...register('surname', { required: 'Please Insert your Surname' })} onChange={handleChange} />
                    {errors.surname && <span className='text-danger'>{errors.surname.message}</span>}
                </div>
            </div>
            <div className="row">
                <div className="col-lg-4 col-md-12 col-sm-12">
                    <label>Gender <span className="text-danger">*</span></label>
                    <select id="" className="form-control" {...register('gender', { required: 'Please Insert your Gender' })} onChange={handleChange} >
                        {values.gender === 'm' ? <option>Male</option> : <option>Female</option>}
                        <option value="m">Male</option>
                        <option value="f">Female</option>
                    </select>
                    {errors.gender && <span className='text-danger'>{errors.gender.message}</span>}
                </div>
                <div className="col-lg-4 col-md-12 col-sm-12">
                    <label>Date of birth <span className="text-danger">*</span></label>
                    <input type="text" id="" className='form-control' {...register('dob', { required: 'please fill in date of birth' })} onChange={handleChange} />
                    {errors.dob && <span className='text-danger'>{errors.dob.message}</span>}
                </div>
                <div className="col-lg-4 col-md-12 col-sm-12">
                    <label>Age</label>
                    <input type="text" id="" className='form-control' {...register('age', { required: 'please fill in your age' })} onChange={handleChange} />
                    {errors.age && <span className='text-danger'>{errors.age.message}</span>}
                </div>
            </div>
            <div className="row">
                <div className='col-lg-4 col-md-12 col-sm-12'>

                    <label>Email <span className="text-danger">*</span></label>
                    <input type="email" id="" required className='form-control' {...register('email', { required: 'Please Insert your correct email' })} onChange={handleChange} />
                    {errors.email && <span className='text-danger'>{errors.email.message}</span>}
                </div>
                <div className="col-lg-4 col-md-12 col-sm-12">

                    <label>Phone 1 <span className="text-danger">*</span></label>
                    <input type="text" id="" required className='form-control' {...register('mobile', { required: 'Please Insert your mobile number ' })} onChange={handleChange} />
                    {errors.mobile && <span className='text-danger'>{errors.mobile.message}</span>}
                </div>
                <div className='col-lg-4 col-sm-12 col-md-12'>
                    <label>Phone 2</label>
                    <input type="text" className='form-control' {...register('mobile1')} onChange={handleChange} />
                    {errors.mobile1 && <span className='text-danger'>{errors.mobile1.message}</span>}
                </div>

            </div>
             </div>
            </div>

        </div>
    </div>
  )
}

export default BasicInfo
